import { Slot } from '../../react-slot/dist/index.module.js';
import * as React from 'react';
import _extends from '../../../@babel/runtime/helpers/esm/extends.js';

const Primitive=["a","button","div","h2","h3","p","img","span","svg"].reduce(((i,s)=>({...i,[s]:/*#__PURE__*/React.forwardRef(((i,n)=>{const{asChild:a,...m}=i,d=a?Slot:s;return i.as&&console.error(o),/*#__PURE__*/React.createElement(d,_extends({},m,{ref:n}))}))})),{});const o="Warning: The `as` prop has been removed in favour of `asChild`. For details, see https://radix-ui.com/docs/primitives/overview/styling#changing-the-rendered-element";

export { Primitive };
